module.exports = __webpack_public_path__ + "static/38invgde-1b390a8236f962505e0136725fae649e.gif";